import socket from './socket.js';

export const search = (data, headers) => socket.get('/search', data, headers);
